__turbopack_context__.v({
  "className": "biz_udpgothic_612b07ee-module__0UTQDq__className",
});
